export default __webpack_public_path__ + "static/media/PlaceOrdersInstantly.99c1205d.svg";